$(document).ready(function(){
	$('.jsFooterTrigger').on('click', function () {
		$(this).toggleClass('is-active');
		$(this).closest('.footer__title').next('.footer__dropdown').slideToggle(300);
	})
});
